<h2 mat-dialog-title>Leave group?</h2>
<mat-dialog-content>
  <p>Your workouts will be saved.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="noSelected()" fxFlex>No</button>
  <button class="yes-button" mat-button color="warn" (click)="yesSelected()" cdkFocusInitial fxFlex>Leave</button>
</mat-dialog-actions>
